export const blockIconsMapsLocalShipping = (
	<span className='material-symbols-outlined'>local_shipping</span>
);
